// extracted by mini-css-extract-plugin
export default {"bundle_card":"BundlePackageGroup_bundle_card__5Jdrx","card_holder":"BundlePackageGroup_card_holder__OvUJc","bundle_group_content":"BundlePackageGroup_bundle_group_content__S+eSR"};